import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { ManageAccounts } from '@mui/icons-material';
import { useAuth } from '@/hooks/useAuth';
import { useAppDispatch } from '@/store';
import { stopImpersonation } from '@/store/auth/authSlice';

const ROLE_COLORS = {
  client:  { bg: '#2e7d32', hover: '#1b5e20', text: '#ffffff' }, // green
  expert:  { bg: '#1976d2', hover: '#0d47a1', text: '#ffffff' }, // blue
  default: { bg: '#e65100', hover: '#bf360c', text: '#ffffff' }, // orange fallback
};

export const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, user } = useAuth();
  const dispatch = useAppDispatch();

  if (!isImpersonating) return null;

  const userName = [user?.name, user?.surname].filter(Boolean).join(' ') || user?.email || '';
  const role = user?.roles?.includes('client') ? 'client'
    : user?.roles?.includes('expert') ? 'expert'
    : 'default';
  const colors = ROLE_COLORS[role];

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 12,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2000,
        pointerEvents: 'none',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 2,
          py: 0.75,
          borderRadius: 6,
          backgroundColor: colors.bg,
          color: colors.text,
          pointerEvents: 'auto',
          whiteSpace: 'nowrap',
        }}
      >
        <ManageAccounts fontSize="small" />
        <Typography variant="body2" fontWeight="bold">
          Від імені: {userName}
        </Typography>
        <Button
          size="small"
          onClick={() => dispatch(stopImpersonation())}
          sx={{
            ml: 0.5,
            color: colors.bg,
            backgroundColor: colors.text,
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.85)' },
            minWidth: 0,
            px: 1.5,
            py: 0.25,
            fontSize: 12,
          }}
        >
          Повернутись
        </Button>
      </Paper>
    </Box>
  );
};
